import { render, staticRenderFns } from "./OTPAuth.vue?vue&type=template&id=0c953896&scoped=true"
import script from "./OTPAuth.vue?vue&type=script&lang=js"
export * from "./OTPAuth.vue?vue&type=script&lang=js"
import style0 from "./OTPAuth.vue?vue&type=style&index=0&id=0c953896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c953896",
  null
  
)

export default component.exports